import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-76535411"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "revenue" };
const _hoisted_2 = { class: "revenue__header" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "revenue__title" };
const _hoisted_5 = { class: "revenue__total" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "revenue__sign" }, "R$", -1));
const _hoisted_7 = { class: "revenue__highlight" };
const _hoisted_8 = { class: "revenue__description" };
const _hoisted_9 = { class: "revenue__indicators" };
const _hoisted_10 = { class: "revenue__caption" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "revenue__caption--dot" }, null, -1));
const _hoisted_12 = { class: "revenue__caption" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "revenue__caption--dot revenue__caption--dot-highlight" }, null, -1));
const _hoisted_14 = { class: "overview" };
const _hoisted_15 = { class: "overview__tag" };
const _hoisted_16 = { class: "overview__percentage" };
const _hoisted_17 = { class: "overview__percentage--text" };
const _hoisted_18 = { class: "overview__percentage--highlight" };
const _hoisted_19 = { class: "overview__percentage--text" };
import SkeletonLoader from '@/components/_atoms/SkeletonLoader.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WelcomeSkeleton',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                            src: require(`@/assets/img/icons/welcome/smile.svg`),
                            alt: _ctx.$t('360.dialog.alert-icon')
                        }, null, 8, _hoisted_3),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('welcome.oto-impact.title')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("p", null, [
                            _hoisted_6,
                            _createElementVNode("span", _hoisted_7, [
                                _createVNode(SkeletonLoader, {
                                    height: "25px",
                                    width: "154px"
                                })
                            ]),
                            _createElementVNode("span", _hoisted_8, [
                                _createTextVNode(_toDisplayString(_ctx.$t('welcome.oto-impact.total-brand-revenue')) + " ", 1),
                                _createVNode(SkeletonLoader, {
                                    height: "15px",
                                    width: "50px"
                                })
                            ])
                        ])
                    ]),
                    _createVNode(SkeletonLoader, {
                        height: "10px",
                        width: "230px"
                    }),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('welcome.oto-impact.general-revenue')), 1)
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("p", null, _toDisplayString(_ctx.$t('welcome.oto-impact.oto-influence')), 1)
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('welcome.oto-impact.last-30-days')), 1),
                    _createElementVNode("p", _hoisted_16, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('welcome.oto-impact.overview-title')), 1),
                        _createElementVNode("span", _hoisted_18, [
                            _createVNode(SkeletonLoader, {
                                height: "30px",
                                width: "82px"
                            })
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('welcome.oto-impact.total-revenue')), 1)
                    ])
                ])
            ], 64));
        };
    }
});
